import {
    CALL_COMPLETED,
    CATCH_ERROR,
    SELECT_FILTER,
    START_CALL,
} from "../ActionTypes/queriesAdminActionTypes";

const createAction = (type, payload = null) => ({ type, payload });

export const startCall = () => createAction(START_CALL);
export const callCompleted = (payload) => createAction(CALL_COMPLETED, payload);
export const catchError = (error) => createAction(CATCH_ERROR, { error });

// commands
export const selectFilter = (filterType, filterValue) =>
    createAction(SELECT_FILTER, { type: filterType, value: filterValue });
